import { Component, Inject, Input } from '@angular/core';
import { AbstractDialogComponent } from '../../../../Core/Dialogs/components/AbstractDialog/abstract-dialog.component';
import { CoreDialogService } from '../../../../Core/Dialogs/services/dialog.service';
import { Observable } from 'rxjs';
import { messageSeverityEnum } from '../../../Misc/enums/message-severity.enum';
import { TargetingPreferencesService } from '../../services/targeting-preferences.service';
import { MessageService } from 'primeng/api';
import { LocalizationService } from '../../../../Core/Localization/services/localization.service';
import { ButtonTypesEnum } from '../../../Forms/enums/button-types.enum';
import { APP_BASE_HREF } from '@angular/common';
import { ConfigService } from '../../../../Core/Config/services/config.service';

@Component({
    selector: 'agpr-buy-quota-dialog',
    templateUrl: './buy-quota-dialog.component.html',
    styleUrls: ['./buy-quota-dialog.component.scss'],
    standalone: false
})
export class BuyQuotaDialogComponent extends AbstractDialogComponent {

    readonly messageSeverities = messageSeverityEnum;
    readonly buttonTypes = ButtonTypesEnum;
    quotaUrl: string;
    contactLink: string;

    @Input() confirmAction: (selectedAmount: number) => Observable<any>;

    consent1 = false;
    consent2 = false;

    loading: boolean = false;
    selectedAmount: number = 5000;

    constructor(
        @Inject(APP_BASE_HREF) public appBaseHref: string,
        public coreDialogService: CoreDialogService,
        public messageService: MessageService,
        public localizationService: LocalizationService,
        public targetingPreferencesService: TargetingPreferencesService,
        public configService: ConfigService
    ) {
        super(coreDialogService, 'BuyQuota');
        this.quotaUrl = appBaseHref + 'Email-Packages';
        this.setContactLink();
    }

    ok(): void {
        if (this.confirmAction) {
            this.loading = true;
            this.confirmAction(this.selectedAmount).subscribe({
                next: () => {
                    this.messageService.add({
                        severity: this.messageSeverities.success,
                        summary: this.localizationService.transform('Discover.distributionDashboard.getMoreRecipients.purchaseComplete'),
                    });
                    this.closeDialog();
                },
                error: () => this.loading = false
            });
            return;
        }
        this.closeDialog(true);
    }

    cancel(): void {
        this.closeDialog(false);
    }

    setContactLink() {
        if (this.configService.brandGUIDIsBurrelles()) {
            this.contactLink = 'mailto:inquiry@burrelles.com';
        } else if (this.configService.brandGUIDIsUnicepta()) {
            this.contactLink = 'https://www.unicepta.com/media-database-support';
        } else if (this.configService.brandGUIDIsPaMedia()) {
            this.contactLink = 'mailto:mediapointsupport@pressassociation.com';
        } else {
            this.contactLink = 'https://www.agilitypr.com/contact/';
        }
    }
}
